import React from "react";
import HotkeysIconSvg from "../../img/controls/hotkeys-icon-svg.js";

export default function GrpGameMenu() {
  const infoIcon = "img/controls/info-icon.svg";
  const homeIcon = "img/controls/home-icon.svg";
  const soundOn = "img/controls/sound-on-icon.svg";
  const musicOn = "img/controls/music-on-icon.svg";
  const betHistoryIcon = "img/controls/bet-history-icon.svg";
  
  return (
    <div className="game-controls-sound-screenshot">
      <div className="game-controls-footer-details">
        <div className="game-controls-footer-right">
          <img
            className="ms-3"
            width={24}
            height={24}
            src={homeIcon}
            alt="home-icon"
          />
          <button disabled={true} className="ms-3 button-icon">
            <img
              width={24}
              height={24}
              src={betHistoryIcon}
              alt="bet-history-icon"
            />
          </button>
          <img
            className="ms-3"
            width={24}
            height={24}
            src={infoIcon}
            alt="info-icon"
          />
          <HotkeysIconSvg className="ms-3" fill={"#01aaa0"} />
          <div className="position-relative">
            <img
              className="ms-3"
              width={24}
              height={24}
              src={soundOn}
              alt={"sound-on-icon"}
            />
          </div>
          <div className="position-relative">
            <img
              className="ms-3"
              width={24}
              height={24}
              src={musicOn}
              alt={"music-on-icon"}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
